@if (ticket(); as ticket) {
  <div class="ticket-tooltip">
    <div class="ticket-tooltip__header">{{ ticket.name }}</div>
    @if (!ready()) {
      <div class="ticket-tooltip__body ticket-tooltip__body--loading">
        <sim-spinner [diameter]="24" [strokeWidth]="3" />
      </div>
    } @else {
      <div class="ticket-tooltip__body">
        <div
          class="ticket-tooltip__status"
          [style.background]="statusStrip().background"
          [style.--ticket-tooltip-status-color]="statusStrip().color"
        >
          <span class="ticket-tooltip__status-main">
            @if (statusIcon()) {
              <sim-icon [icon]="statusIcon()" [sizeInPx]="24" [color]="statusStrip().color" />
            }
            <span class="ticket-tooltip__status-label">{{ statusLabel() }}</span>
          </span>
          @if (isFinished() || dueDate()) {
            <ticket-due-date [color]="dueDateColor()" [date]="dueDate()" [finished]="isFinished()" />
          }
        </div>

        @if (description()) {
          <p class="ticket-tooltip__description">{{ description() }}</p>
        }

        @if (images().length > 0) {
          <div class="ticket-tooltip__pictures">
            @for (image of visibleImages(); track image.id; let i = $index) {
              <sim-attachment-tile
                type="image"
                [src]="imageUrls()[i]"
                [alt]="image.name"
                [class.ticket-tooltip__tile--clickable]="canShowMore"
                (click)="showMore('images')"
              />
            }
            @if (moreImages() > 0) {
              <sim-attachment-tile
                [more]="moreImages()"
                [class.ticket-tooltip__tile--clickable]="canShowMore"
                (click)="showMore('images')"
              />
            }
          </div>
        }

        @if (checklist(); as checklist) {
          <div class="ticket-tooltip__checklist">
            <span class="ticket-tooltip__checklist-label">{{
              checklistLabel(checklist.completed, checklist.total)
            }}</span>
            <div class="ticket-tooltip__checklist-track">
              <div class="ticket-tooltip__checklist-bar" [style.width.%]="checklist.percent"></div>
            </div>
          </div>
        }

        @if (hasAsset() || hasContractor()) {
          <div class="ticket-tooltip__badges">
            @if (hasAsset()) {
              <sim-color-badge class="ticket-tooltip__badge" color="var(--ui-primary-accent, #e0e9f9)">
                <sim-icon icon="assignment" [sizeInPx]="14" />
                <ng-container i18n="@@TICKET_TOOLTIP_BADGE_ASSET">Asset</ng-container>
              </sim-color-badge>
            }
            @if (hasContractor()) {
              <sim-color-badge class="ticket-tooltip__badge" color="var(--ui-primary-accent, #e0e9f9)">
                <sim-icon icon="person" [sizeInPx]="14" />
                <ng-container i18n="@@TICKET_TOOLTIP_BADGE_CONTRACTOR">Contractor</ng-container>
              </sim-color-badge>
            }
          </div>
        }

        @if (canShowMore) {
          <div class="ticket-tooltip__footer">
            <button
              type="button"
              class="ticket-tooltip__show-more"
              (click)="showMore()"
              i18n="@@TICKET_TOOLTIP_SHOW_MORE"
            >
              Show more
            </button>
          </div>
        }
      </div>
    }
  </div>
}
